
const About = () => {
  return (
    <div className="about">
      <div className="product__top">
        <h1>Home /</h1> <h2>About</h2>
      </div>

      <div className="about_grid">
        <div className="img_aboutw">
         <img src="./images/hero.jpeg" alt="hero"></img>
        </div>
        
        <article>
          <h1>Our Story</h1>
          <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Fugiat accusantium sapiente tempora sed dolore esse deserunt eaque excepturi, delectus error accusamus vel eligendi, omnis beatae. Quisquam, dicta. Eos quod quisquam esse recusandae vitae neque dolore, obcaecati incidunt sequi blanditiis est exercitationem molestiae delectus saepe odio eligendi modi porro eaque in libero minus unde sapiente consectetur architecto. Ullam rerum, nemo iste ex, eaque perspiciatis nisi, eum totam velit saepe sed quos similique amet. Ex, voluptate accusamus nesciunt totam vitae esse iste.</p>
        </article>
      </div>
    </div>
  )
}

export default About